
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["connectWS","sendEvent","closeWS","getTradeBlotterAfterALotTime","test"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "7290ed7be97708a897fe.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "7290ed7be97708a897fe.worker.js");
					addMethods(w, methods)
					
					return w
				}
			